import { Link } from "react-router-dom"
import { Button } from "@/components/ui/button"

export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-4">
      <span className="text-6xl font-bold text-muted-foreground/30">404</span>
      <h1 className="text-xl font-semibold">Page not found</h1>
      <p className="text-sm text-muted-foreground">The page you're looking for doesn't exist.</p>
      <Button asChild size="sm" className="mt-2">
        <Link to="/">Back to Dashboard</Link>
      </Button>
    </div>
  )
}
